/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import './address';
import '../../common/time';
import '../../common/location';
import './return_item';

const $root = ($protobuf.roots['default']|| ($protobuf.roots['default'] = new $protobuf.Root()));

const jsonData = {
  "squareup": {
    "nested": {
      "solidshop": {
        "nested": {
          "model": {
            "nested": {
              "ReturnAuthorization": {
                "fields": {
                  "id": {
                    "type": "int32",
                    "id": 1,
                    "rule": "optional"
                  },
                  "orderNumber": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "sqFromAddress": {
                    "type": "squareup.solidshop.model.Address",
                    "id": 3,
                    "rule": "optional"
                  },
                  "createdAt": {
                    "type": "squareup.common.time.DateTime",
                    "id": 4,
                    "rule": "optional"
                  },
                  "updatedAt": {
                    "type": "squareup.common.time.DateTime",
                    "id": 5,
                    "rule": "optional"
                  },
                  "phoneNumber": {
                    "type": "squareup.common.location.Phone",
                    "id": 6,
                    "rule": "optional"
                  },
                  "returnItem": {
                    "type": "squareup.solidshop.model.ReturnItem",
                    "id": 7,
                    "rule": "repeated"
                  },
                  "number": {
                    "type": "string",
                    "id": 8,
                    "rule": "optional"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.solidshop?.nested?.model?.nested?.ReturnAuthorization) {
	$root.addJSON(jsonData);
}

/**
 * SOURCE ReturnAuthorization @ squareup/solidshop/model/return_authorization.proto at 14:1
 */
export const ReturnAuthorization = $root.lookupType('squareup.solidshop.model.ReturnAuthorization');
fixType(ReturnAuthorization);
Builder.createAndAttachToType(ReturnAuthorization);
